import { PromoRollSynthJobFieldsFragment, PromoRollSynthJobStatus } from '@entities/promo-roll-synth-job/model';

export type DuplicateJobKind = 'completed' | 'active' | null;

export const getDuplicateJobKind = (
  existingJobIds: Set<string>,
  job: Pick<PromoRollSynthJobFieldsFragment, 'id' | 'status'> | null | undefined
): DuplicateJobKind => {
  if (!job || !existingJobIds.has(job.id)) return null;

  if (job.status === PromoRollSynthJobStatus.Completed) return 'completed';
  if (job.status === PromoRollSynthJobStatus.Created || job.status === PromoRollSynthJobStatus.InProgress) {
    return 'active';
  }

  return null;
};
